import { defineStore } from 'pinia'

const useAppStore = defineStore('app', {
  state: () => ({
    isVerticalNavMini: false,
  }),

  actions: {
    setIsVerticalNavMini(v) {
      this.isVerticalNavMini = v
    },
  },

  persist: true,
})

export default useAppStore
